import { SafeTaxiCheckerComponent } from "../components/safe-taxi-checker/safe-taxi-checker.component";
import { RRSSLinks } from "./rrss-links";
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

export const Projects: any[] = [
  {
    name: 'Alerta temprana',
    available: true,
    slug: 'overpass',
    description: 'Monitoreo de alertas tempranas para inundaciones.',
    color: 'blue-lighten',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web2.webp?alt=media&token=7d8ff643-01ca-46f6-9323-562129224dfb',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fresume-cover.webp?alt=media&token=75c9fbe6-80cd-4b38-bd96-1b7caf4f6e28',
    },
    features: [
      {
        title: 'Medicion de líquidos',
        icon: 'bi-moisture',
        photoUrl: ''
      },
      {
        title: 'Prevención de accidentes',
        icon: 'bi-truck-front',
        photoUrl: ''
      },
      {
        title: 'Alerta temprana',
        icon: 'bi-cone-striped',
        photoUrl: ''
      }
    ],
    data: {
      gallery: [
        {
          title: 'Monitoreo de inundaciones',
          description: 'El monitoreo del nivel de agua en pasos a desnivel utiliza sensores avanzados para detectar acumulaciones de agua. Esto permite activar rápidamente equipos de contingencia, evitando inundaciones peligrosas y asegurando la seguridad de todos los ciudadanos.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web5.webp?alt=media&token=6c8415c0-cb8f-48de-a7f7-ccc8f51c5f0d',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web.webp?alt=media&token=6af72ee8-cc37-4826-bc34-47653dd86c7b'
          ],
          topic: 'Pasos a desnivel'
        },
        {
          title: '',
          subtitle: '¿Cómo funciona?',
          description: 'El sistema mide continuamente el nivel de agua en los pasos a desnivel mediante sensores. Cuando el agua alcanza un nivel crítico, se envía una señal a la Unidad de Gestión de Riesgos (UGR), que despliega brigadas para intervenir antes de que ocurra una inundación grave.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web3.webp?alt=media&token=0bbc54c8-2ce8-4201-ba13-8d2a79e7e712',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web5.webp?alt=media&token=6c8415c0-cb8f-48de-a7f7-ccc8f51c5f0d',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web7.webp?alt=media&token=7474685a-8bf1-4ed9-8198-4ddf41b5d90f'
          ],
          topic: 'Pasos a desnivel'
        },
        {
          title: '',
          subtitle: 'Ventajas y aplicaciones',
          description: 'Este sistema proporciona una respuesta rápida ante inundaciones, protegiendo a los ciudadanos y la infraestructura. Su implementación asegura intervenciones eficientes y oportunas, reduciendo los daños y manteniendo la seguridad en la ciudad.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web6.webp?alt=media&token=bd60b467-d3a2-4e54-8d31-8ecb0088ccc7',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web.webp?alt=media&token=6af72ee8-cc37-4826-bc34-47653dd86c7b'
          ],
          topic: 'Pasos a desnivel'
        },
        {
          title: 'Monitoreo de lluvias',
          description: 'Instalación de pluviómetros para medir la cantidad de precipitación en diferentes puntos de la ciudad. Estos dispositivos permiten anticipar riesgos de lluvias intensas y posibles inundaciones.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web8.webp?alt=media&token=379def2a-c928-416a-a05f-9c37adae80e1'
          ],
          topic: 'Pluviómetros'
        },
        {
          title: '',
          subtitle: '¿Cómo funciona?',
          description: 'Los pluviómetros miden la cantidad de lluvia en milímetros y envían la información en tiempo real a una plataforma centralizada. Cuando las precipitaciones superan ciertos niveles, se activan alertas que pueden ser visualizadas por los ciudadanos y gestionadas por autoridades de emergencia.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web9.webp?alt=media&token=8a5923e3-5618-461a-9790-d6471fb86295'
          ],
          topic: 'Pluviómetros'
        },
        {
          title: '',
          subtitle: 'Ventajas y aplicaciones',
          description: 'Permite alertas tempranas en caso de lluvias fuertes, mejora la capacidad de respuesta ante emergencias, ayuda a la planificación de recursos en situaciones de riesgo, y facilita la toma de decisiones basadas en datos en tiempo real.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FearlyAlert%2Fcover-web.webp?alt=media&token=6af72ee8-cc37-4826-bc34-47653dd86c7b'
          ],
          topic: 'Pluviómetros'
        }
      ]
    },
    mapInfo: {
      title: 'Sensores de alerta temprana',
      description: 'El mapa muestra la ubicación de los sensores de alerta temprana instalados en la ciudad, utilizados para monitorear condiciones ambientales y prevenir riesgos.',
      topics: {
        // sensor: ['/topic/EMUDL'],
        location: ['pluviometer'],
        geojson: []
      }
    }
  },
  {
    name: 'Parqueo tarifado',
    available: true,
    slug: 'parking',
    color: 'cherry',
    description: 'Gestiona el pago de estacionamiento del perímetro de restricción vehicular.',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fcover-web-1.webp?alt=media&token=8e1c98a0-0f5f-45db-9991-4166f21e3d4b',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fparkprev.webp?alt=media&token=6f036371-e915-49f1-9c26-f918c1aeb1f0',
    },
    features: [
      {
        title: 'Parqueo',
        icon: 'bi-p-circle',
        photoUrl: ''
      },
      {
        title: 'Remoto',
        icon: 'bi-phone',
        photoUrl: ''
      },
      {
        title: 'Locación',
        icon: 'bi-geo-alt',
        photoUrl: ''
      }
    ],
    data: {
      gallery: [
        {
          title: '¿Qué es el parqueo tarifado?',
          description: 'El parqueo tarifado es un sistema que regula el uso de espacios de estacionamiento en área de restricción de la ciudad. A través de la app Innova, los usuarios pueden gestionar y pagar su estacionamiento de forma rápida y conveniente.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fcover.webp?alt=media&token=c0cbd427-d478-41b4-8c9e-85ad740417fe',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fcover-web3.webp?alt=media&token=2b47a5b1-0e83-4d59-867b-8290ccc2b8e9'
          ],
          topic: 'Parqueo tarifado',
          subtitle: ''
        },
        {
          title: '',
          topic: 'Parqueo tarifado',
          subtitle: '¿Cómo funciona?',
          description: 'Con la app Innova, estacionar en la ciudad es fácil y accesible. Los usuarios pueden seleccionar su calle, ingresar la placa del vehículo, y realizar el pago directamente desde sus dispositivos móviles.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fprev.webp?alt=media&token=992f9e52-9640-405e-976c-109dba25d975',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fcover-web5.webp?alt=media&token=5fac47bc-ae25-4a8a-9b91-e03c614e8a83'
          ]
        },
        {
          title: '',
          topic: 'Parqueo tarifado',
          subtitle: 'Ventajas y aplicaciones',
          description: 'La app Innova facilita el acceso a los espacios de estacionamiento y simplifica el proceso de pago, proporcionando una experiencia de usuario cómoda y eficiente.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fcover-web2.webp?alt=media&token=793b59c8-65e5-469e-b6f4-5f9b256d43c8',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fparking%2Fcover-web6.webp?alt=media&token=67a3144e-13fc-42fd-9803-ecd1489740c9'
          ]
        }
      ]
    },
    mapInfo: {
      title: 'Restricción vehicular',
      description: 'El parqueo vehicular está permitido solo en la zona marcada en el mapa y en las aceras pintadas de amarillo.',
      topics: {
        sensor: [],
        location: [],
        geojson: ['restriction']
      }
    }
  },
  {
    name: 'Medio ambiente',
    available: true,
    slug: 'environment',
    description: 'Consiste en obtener datos precisos de calidad de aire, cantidades de CO2, temperatura humedad, etc. a traves estaciones ubicadas en distintos puntos de nuestra ciudad.',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web.webp?alt=media&token=88e71943-9fd9-440e-a726-b143914dfd8b',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fresume-cover.webp?alt=media&token=dfb70f9e-df41-4c5c-8270-0be04f56be58'
    },
    color: 'green',
    features: [
      {
        title: 'Calidad de aire',
        icon: 'bi-cloud-drizzle',
        photoUrl: ''
      },

      {
        title: 'Temperatura',
        icon: 'bi-thermometer-sun',
        photoUrl: ''
      },
      {
        title: 'Nivel de CO2',
        icon: 'bi-lungs',
        photoUrl: ''
      },
    ],
    data: {
      gallery: [
        {
          title: '¿En que consiste el monitoreo ambiental?',
          topic: 'Monitoreo ambiental',
          subtitle: '',
          description: 'La medición ambiental implica el uso de sensores para evaluar los niveles de contaminantes en el ambiente. Estos sensores registran parámetros como el Índice de Calidad del Aire (ICA), la temperatura, humedad relativa y partículas en suspensión, proporcionando información esencial para monitorear y mejorar la salud ambiental.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web2.webp?alt=media&token=695610c8-783e-4b3d-833e-ce056bb3bfcf',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web3.webp?alt=media&token=24508498-09bf-41b3-9ffc-96bc952f4705'
          ]
        },
        {
          title: '¿Qué es la Red MoniCA?',
          topic: 'Red MoniCA',
          subtitle: '',
          description: 'Red de Monitoreo de la Calidad del Aire encargada de recolectar datos para la toma de decisiones en favor del medio ambiente. Las estaciones de monitoreo se encuentran repartidas en: zona norte (SEMAPA), zona sur (Parque Kanata) y (Fuerza Aérea Militar), zona oeste (Coña Coña), tal como se describe en el gráfico.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web3.webp?alt=media&token=24508498-09bf-41b3-9ffc-96bc952f4705',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web8.webp?alt=media&token=e1dfb820-34bd-405b-8f2f-baa7d2e7b53f'
          ]
        },
        {
          title: '',
          topic: 'Red MoniCA',
          subtitle: 'Historia',
          description: 'Gracias a la iniciativa de la Fundación Suiza de Cooperación para el Desarrollo Técnico (SwissContact) y al concurso de la Honorable Alcaldía Municipal de Cochabamba y de la Universidad Católica Boliviana San Pablo, se inició la implementación de la primera Red de Monitoreo de la Calidad del Aire de nuestro país a partir del 2001.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web5.webp?alt=media&token=03c67ab3-7567-46cc-9720-bd846c28baba',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web7.webp?alt=media&token=adc2407e-447d-40b6-9159-12fbcd90b97e'
          ]
        },
        {
          title: 'Monitoreo ambiental con sensores',
          topic: 'Sensores LoRaWAN',
          subtitle: '',
          description: 'Los sensores instalados en diversos puntos de la ciudad capturan datos sobre la concentración de contaminantes en el aire. Estos dispositivos también miden la temperatura y la humedad relativa, permitiendo una evaluación completa de las condiciones ambientales. Los datos se transmiten a un centro de control donde se analizan y se publican para informar a los ciudadanos.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web6.webp?alt=media&token=23fc0ef5-f6d3-434a-9ed3-8c549d3cf7a3',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web5.webp?alt=media&token=03c67ab3-7567-46cc-9720-bd846c28baba'
          ]
        },
        {
          title: '',
          topic: 'Sensores LoRaWAN',
          subtitle: 'Ventajas y aplicaciones',
          description: 'Monitorear la calidad del aire ayuda a identificar áreas con altos niveles de contaminación y a tomar medidas para mejorar la salud pública. La información precisa sobre el ICA, la temperatura y la humedad relativa permite a los residentes y autoridades tomar decisiones informadas para proteger la salud y el medio ambiente.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fenvironment%2Fcover-web4.webp?alt=media&token=64ad67cb-3496-49a1-901b-45cdd7eac7b4'
          ]
        }
      ]
    },
    mapInfo: {
      title: 'Sensores de medio ambiente',
      description: 'El mapa muestra los sensores de medición ambiental distribuidos en la ciudad, que registran datos sobre CO2, humedad, temperatura y otros factores clave para el monitoreo del medio ambiente.',
      topics: {
        // sensor: ['/topic/EMCO2'],
        // location: [],
        geojson: []
      }
    }
  },
  {
    name: 'Movilidad urbana inteligente',
    available: true,
    slug: 'panels',
    description: 'Señalizacion y guías en tiempo real del tráfico urbano, tanto luminosos como auditivos.',
    color: 'green-lighten',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web.webp?alt=media&token=3587ec95-9a77-47d2-a47a-4b585295c456',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fresume-cover.webp?alt=media&token=0cc70bb7-7995-4d83-9018-d3963ce50900'
    },
    features: [
      {
        title: 'Rutas eficientes',
        icon: 'bi-sign-turn-slight-right',
        photoUrl: ''
      },
      {
        title: 'Tráfico inteligente',
        icon: 'bi-clock',
        photoUrl: ''
      },
      {
        title: 'Mensajes en tiempo real',
        icon: 'bi-chat-left-text',
        photoUrl: ''
      }
    ],
    data: {
      gallery: [
        {
          title: 'Movilidad urbana inteligente',
          topic: 'Movilidad urbana',
          subtitle: '',
          description: 'Movilidad urbana inteligente se refiere al uso de tecnología avanzada para mejorar la eficiencia, seguridad y sostenibilidad del transporte en las ciudades. A través de proyectos innovadores, como la instalación de paneles, semáforos inteligentes entre otros.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web6.webp?alt=media&token=f28316d3-9f3d-4a04-84db-5da620889d6b',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web.webp?alt=media&token=3587ec95-9a77-47d2-a47a-4b585295c456'
          ]
        },
        {
          title: '',
          topic: 'Paneles inteligentes',
          subtitle: '¿Qué es la señalética inteligente?',
          description: 'La señalética inteligente utiliza letreros digitales en puntos estratégicos de la ciudad para proporcionar información en tiempo real sobre el tráfico, tiempos de viaje y distancias. Además, estos letreros muestran datos útiles como el clima, la hora y alertas importantes, ayudando a los conductores y ciudadanos a tomar decisiones informadas en su desplazamiento diario.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web4.webp?alt=media&token=cebabc58-7da2-49b2-877b-97b649fb8a88'
          ]
        },
        {
          title: '',
          topic: 'Paneles inteligentes',
          subtitle: '¿Como funciona?',
          description: 'Estos letreros inteligentes están conectados a sistemas de monitoreo del tráfico que recopilan y analizan datos en tiempo real. La información sobre el flujo vehicular, tiempos de viaje y condiciones climáticas se actualiza continuamente y se muestra en los letreros, permitiendo a los conductores ajustar sus rutas según la situación actual.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web.webp?alt=media&token=3587ec95-9a77-47d2-a47a-4b585295c456'
          ]
        },
        {
          title: '',
          topic: 'Paneles inteligentes',
          subtitle: 'Ventajas y aplicaciones',
          description: 'La señalética inteligente mejora la gestión del tráfico y la seguridad vial al proporcionar a los conductores información actualizada y relevante. Esto reduce la congestión y facilita una conducción más eficiente. Además, los letreros pueden mostrar mensajes importantes, como alertas meteorológicas o anuncios de emergencia, beneficiando a toda la comunidad.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web4.webp?alt=media&token=cebabc58-7da2-49b2-877b-97b649fb8a88'
          ]
        },
        {
          title: 'Actualización de semáforos',
          topic: 'Semáforos inteligentes',
          subtitle: '',
          description: 'Los semáforos inteligentes utilizan luces LED visibles y emiten señales auditivas para guiar a peatones y conductores. Este sistema mejora la seguridad vial, especialmente para personas con discapacidad visual.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web3.webp?alt=media&token=2efa6b47-5e55-4da5-867a-c4faed7d656a'
          ]
        },
        {
          title: '',
          topic: 'Semáforos inteligentes',
          subtitle: 'Iluminacion LED en paso peatonal',
          description: 'Equipados con luces LED y tecnología de audio, los semáforos indican visual y auditivamente el estado de cruce. Esto asegura una mejor comunicación y seguridad para todos los usuarios de las vías urbanas.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web2.webp?alt=media&token=5e09d97c-45e0-4843-ab51-dd4baed6ad04'
          ]
        },
        {
          title: '',
          topic: 'Semáforos inteligentes',
          subtitle: 'Ventajas y aplicaciones',
          description: 'Los semáforos inteligentes no solo mejoran la accesibilidad para personas con discapacidad visual, sino que también optimizan la gestión del tráfico y aumentan la seguridad en las intersecciones urbanas. Sus luces LED brillantes y señales auditivas proporcionan una experiencia de cruce más segura y eficiente.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2FurbanMobility%2Fcover-web5.webp?alt=media&token=faaa857b-02f3-4df7-8d91-14fcb11224be'
          ]
        }
      ]
    },
    mapInfo: {
      title: 'Localiza nuestros paneles',
      description: 'La señalética inteligente utiliza letreros digitales en puntos estratégicos de la ciudad para proporcionar información en tiempo real sobre el tráfico, tiempos de viaje y distancias.',
      topics: {
        sensor: [],
        location: ['panel'],
        geojson: ['restriction']
      }
    }
  },
  {
    name: 'Iluminación led',
    available: true,
    slug: 'led',
    description: 'Sustitución de luminarias de alumbrado público en gran parte de la ciudad, por luminarias de tecnología LED.',
    color: 'yellow',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fcover-web.webp?alt=media&token=c7354052-1558-4433-8301-66c0d6d3efe7',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fresume-cover.webp?alt=media&token=f1e0234f-413e-4d6a-8e0b-af7591ee8591'
    },
    features: [
      {
        title: 'Luminaria nueva',
        icon: 'bi-lightbulb',
        photoUrl: ''
      },
      {
        title: 'Ahorro',
        icon: 'bi-currency-dollar',
        photoUrl: ''
      },
      {
        title: 'Telegestión',
        icon: 'bi-pc-display-horizontal',
        photoUrl: ''
      }
    ],
    data: {
      gallery: [
        {
          title: '¿Qué es la iluminación LED?',
          topic: 'Iluminación LED',
          subtitle: '',
          description: 'La iluminación LED reemplaza las antiguas luminarias con luces más eficientes y duraderas. Este cambio no solo ahorra energía, sino que también mejora la calidad de la iluminación urbana, contribuyendo a una ciudad más segura y sostenible.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fcover-web2.webp?alt=media&token=40bce3dd-2c78-4d46-83c2-b301505b9b3d',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fcover-web5.webp?alt=media&token=20cab605-bfba-4569-8746-bb29fee01e13'
          ]
        },
        {
          title: '',
          topic: 'Iluminación LED',
          subtitle: '¿Cómo funciona?',
          description: 'Las luminarias LED utilizan diodos emisores de luz, que consumen menos energía y tienen una vida útil más larga en comparación con las bombillas tradicionales. Además, están conectadas a un sistema de telegestión que permite el control y monitoreo remoto, optimizando su funcionamiento y reduciendo costos de mantenimiento.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fcover-web3.webp?alt=media&token=86323629-88a5-4103-907d-611660699c03',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fcover-web6.webp?alt=media&token=1312d627-1e64-4f90-a4c7-6ddd9097bce7'
          ]
        },
        {
          title: '',
          topic: 'Iluminación LED',
          subtitle: 'Ventajas y aplicaciones',
          description: 'La transición a iluminación LED ofrece múltiples beneficios: un ahorro significativo en el consumo de energía, menor impacto ambiental, y una iluminación más brillante y uniforme. La telegestión permite ajustar la intensidad de las luces y detectar fallos de forma remota, mejorando la eficiencia y la gestión de los recursos urbanos.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fled-lights%2Fcover-web4.webp?alt=media&token=77d25cf4-493d-46f3-ac64-dbaaf5f748e7'
          ]
        }
      ]
    }
  },
  {
    name: 'Aplicación Innova',
    available: true,
    slug: 'app-innova',
    description: 'Aplicación municipal oficial de Cochabamba diseñada para facilitar y simplificar la vida de los ciudadanos.',
    color: 'purple',
    bannerId: 'innova',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2Fcover.webp?alt=media&token=d9199df7-5122-42b2-8575-c8509cc3e9fc',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2Finnovaprev.webp?alt=media&token=4cdb213f-e546-4026-adca-dc7be0417c6f'
    },
    features: [
      {
        title: 'App Municipal',
        icon: 'bi-phone',
        photoUrl: ''
      },
      {
        title: 'Trámites',
        icon: 'bi-journal-arrow-up',
        photoUrl: ''
      },
      {
        title: 'Parqueo online',
        icon: 'bi-p-circle',
        photoUrl: ''
      }
    ],
    data: {
      gallery: [
        {
          title: '¿Qué es aplicación INNOVA?',
          topic: 'Innova App',
          subtitle: '',
          description: 'Innova es la aplicación municipal oficial de Cochabamba diseñada para facilitar y simplificar la vida de los ciudadanos. Con esta app, los usuarios pueden acceder a una amplia gama de servicios municipales desde su dispositivo móvil de manera rápida y segura.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F2Innova2025.webp?alt=media&token=825b4790-7614-4a8f-ba67-e7a1da257fbf',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F3Innova2025.webp?alt=media&token=438588d7-62d5-4147-b3d4-bead64239dde'
          ]
        },
        {
          title: '',
          topic: 'Innova App',
          subtitle: 'Características',
          description: 'Innova permite hacer pagos en línea de impuestos y servicios municipales sin necesidad de ir a las oficinas, todo desde la comodidad de tu dispositivo móvil. Además, la app te permite gestionar el parquímetro, con la opción de reservar un espacio para estacionar en zonas reguladas.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F5Innova2025.webp?alt=media&token=0df9f8c5-c094-49a8-b8ad-8264001caf4a'
          ]
        },
        {
          title: '',
          topic: 'Innova App',
          subtitle: 'Características',
          description: 'Innova te ofrece acceso rápido para consultar patentes de vehículos, inmuebles y actividades económicas. Además, puedes reservar canchas deportivas, verificar taxis seguros, revisar infracciones de tránsito y consultar el estado de trámites en subalcaldías. También puedes gestionar reclamos de manera eficiente.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F4Innova2025.webp?alt=media&token=441c9678-8f5d-4348-b231-9bbb065fea9c',
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F6Innova2025.webp?alt=media&token=e4842f2a-216d-4329-a03d-9ab48d1d015d'
          ]
        },
        {
          title: '',
          topic: 'Innova App',
          subtitle: 'Características',
          description: 'Con Innova, puedes gestionar trámites de licencias de funcionamiento y declaraciones juradas de forma rápida. Además, la app te permite reservar citas médicas en hospitales de 2do nivel, facilitando el acceso a la atención de salud.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F7Innova2025.webp?alt=media&token=dbeeb286-9083-43c1-80b1-551dbcf74f98'
          ]
        },
        {
          title: '',
          topic: 'Innova App',
          subtitle: '¿Como descargar INNOVA?',
          description: '¡Descarga la app Innova hoy mismo desde Play Store o App Store y disfruta de todos los servicios municipales al alcance de tu mano! Si prefieres, también puedes acceder a la versión web desde cualquier navegador para realizar tus gestiones de forma rápida y sencilla.',
          photos: [
            'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2Fcover%20innova2025.webp?alt=media&token=ef09fd1e-0495-44a0-a95b-7808952ed62b'
          ]
        }
      ]
    }
  },
  {
    name: 'Gestión de residuos',
    available: false,
    slug: 'trash',
    description: 'Medición del volumen de desechos en contenedores de basura para el control y manejo eficiente de la basura.',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8',
      previewBgUrl: 'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8',
    },
    color: 'yellow',
    features: [
      {
        title: 'Control de basureros',
        icon: 'bi-trash3',
        photoUrl: ''
      },
      {
        title: 'Rutas eficientes',
        icon: 'bi-truck',
        photoUrl: ''
      },
      {
        title: 'Ahorro de recursos',
        icon: 'bi-clock',
        photoUrl: ''
      }
    ],
    data: {
      gallery: [
        {
          title: '¿Qué es la medición de residuos?',
          description: 'La medición de residuos sólidos con sensores es una tecnología que cuantifica y analiza los desechos en contenedores. Esto ayuda a optimizar la recolección, el tratamiento y la planificación de la gestión de residuos en la ciudad.',
          photos: [
            'https://www.cochabamba.bo/img/secciones/smart-city/Soterrado1.jpg',
            'https://firebasestorage.googleapis.com/v0/b/cocha-turismo.appspot.com/o/images%2Fcontenedoresmin.jpg?alt=media&token=26841b9a-6c95-486e-9482-4c1bbddc56e8'
          ]
        },
        {
          title: '¿Cómo funciona?',
          description: 'Sensores instalados en los contenedores miden la distancia entre el sensor y los residuos. Estos sensores envían una señal que rebota en la superficie de los desechos, calculando así la altura de la basura acumulada.',
          photos: [
            'https://www.cochabamba.bo/img/secciones/smart-city/Soterrado2.jpg'
          ]
        },
        {
          title: 'Ventajas y aplicaciones',
          description: 'Esta tecnología permite monitorear la capacidad restante de los contenedores de residuos, facilitando una gestión más eficiente. Con datos precisos, se pueden planificar mejor las rutas de recolección y reducir los costos operativos.',
          photos: [
            'https://www.cochabamba.bo/img/secciones/smart-city/Soterrado3.jpg'
          ]
        }
      ]
    },
    mapInfo: {
      title: 'Basureros',
      description: '',
      topics: {
        location: ['trash']
      }
    }
  },
  {
    available: false,
    slug: 'bikeway',
    mapInfo: {
      title: 'Ciclovía',
      description: '',
      topics: {
        sensor: [],
        location: [],
        geojson: ['bikeway']
      }
    }
  },
  {
    name: "Bitcoin",
    available: false,
    slug: "bitcoin",
    description: "Descubre Bitcoin, la primera criptomoneda descentralizada del mundo. Encuentra el paper de Satoshi Nakamoto y cómo funciona esta tecnología revolucionaria.",
    color: "yellow",
    bannerId: "bitcoin-paper",
    assets: {
      backgroundUrl: "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2FCover-BTC.png?alt=media&token=e135f703-406c-4347-a246-818d4be3e176",
      previewBgUrl: ""
    },
    features: [
      {
        title: "Activo",
        icon: "bi-currency-bitcoin",
        photoUrl: ""
      },
      {
        title: "Seguro",
        icon: "bi-shield-lock",
        photoUrl: ""
      },
      {
        title: "Libre",
        icon: "bi-hdd-network",
        photoUrl: ""
      }
    ],
    data: {
      gallery: [
        {
          title: "¿Qué es Bitcoin?",
          topic: "Introducción a BTC",
          subtitle: "",
          description: "Bitcoin es una moneda digital descentralizada que permite transferencias seguras sin intermediarios a través de la tecnología blockchain.",
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fwat.png?alt=media&token=dc697e58-1c7f-4e47-9b3e-8d5f127c8395"
          ]
        },
        {
          title: "",
          topic: "Red Bitcoin",
          subtitle: "Cómo funciona",
          description: "Cada transacción se registra en una cadena de bloques pública y es validada por nodos descentralizados mediante un proceso llamado minería.",
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fblock.png?alt=media&token=832fc1f0-f4a3-48a1-ac2c-54d355193fbe"
          ]
        },
        {
          title: "",
          topic: "Whitepaper de Bitcoin",
          subtitle: "El documento original",
          description: "El documento técnico de Bitcoin, publicado por Satoshi Nakamoto en 2008, describe cómo funciona el sistema y su mecanismo de consenso.",
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fwat2.png?alt=media&token=f57c5c3e-e2c9-41ca-98d1-fcf8c41589c4"
          ]
        },
        {
          title: "",
          topic: "Seguridad en Bitcoin",
          subtitle: "Protegiendo tus BTC",
          description: "Se pueden almacenar BTC en billeteras digitales con tecnología P2P, en exchanges centralizados o en hardware wallets para mayor seguridad.",
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fprot3.png?alt=media&token=72062e05-6e94-49f3-ae4b-5599527a522f",
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fprot.webp?alt=media&token=44f699e9-e43c-455e-a9db-d8ece427c674",
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fprot2.webp?alt=media&token=a422492c-6047-4786-9130-ec5492e4e229",
          ]
        },
        {
          title: "",
          topic: "Cómo adquirir Bitcoin",
          subtitle: "Métodos y opciones",
          description: "BTC se puede comprar en exchanges, cajeros automáticos o de persona a persona, y almacenarse en billeteras digitales o hardware wallets.",
          photos: [
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fbuy2.png?alt=media&token=96ab07f6-e6dc-47e8-a0b7-3cf5a27982d7",
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fbuy3.webp?alt=media&token=23aadef0-d4ff-459c-b0fe-b9079bd12aae",
            "https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fbuy.webp?alt=media&token=0cfa453d-f94d-4bcd-a767-982e1e89571f"
          ]
        }
      ]
    }
  }
];

export const Banners: any[] = [
  {
    name: 'Mapa',
    slug: 'map',
    description: 'Explora la ciudad',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fhome%2FmapCover.png?alt=media&token=0c90869e-6622-4839-8059-c8821c5cea00',
      videoUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/videos%2FsmartCity%2Fmain-map.mp4?alt=media&token=3d864402-8d8d-438f-9d91-e5fef77ba3dc'
    },
    link: '',
    redirect: false,
    buttonLabel: 'Ver mapa',
    hasFunction: false
  },
  {
    name: 'Visita Cocha',
    slug: 'visita-cocha',
    description: 'Conoce la ciudad en nuestra plataforma turística',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fvisita-cocha%2Fvisita-cocha-banner-home.jpg?alt=media&token=7b0e1700-048f-449d-9c5a-e6cc59becf2c',
    },
    link: 'https://visita.cochabamba.bo',
    redirect: true,
    buttonLabel: 'Visita Cocha',
    hasFunction: false
  },
  {
    name: 'Innova App',
    slug: 'app-innova',
    description: 'Saca provecho de nuestra plataforma de trámites y servicios',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Finnova%2F2025%2F1Innova2025.webp?alt=media&token=4b18fb6e-c003-4c54-9d19-2172bd47bc3c',
    },
    link: '',
    buttonLabel: 'Descargar app',
    redirect: false,
    hasFunction: true,
    action: () => {
      redirectBasedOnDevice();
    }
  },
  {
    name: 'Taxi Seguro',
    slug: 'taxiChecker',
    description: 'Ingresa la placa de un vehículo y verifica si pertenece a Taxi Seguro',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fsafe-taxi%2Fsafe-taxi-banner.jpg?alt=media&token=d59cb559-b91a-487b-ac01-5b1da41b1100'
    },
    link: '',
    buttonLabel: 'Verificar placa',
    redirect: false,
    hasFunction: true,
    action: (dialogService: DialogService) => {
      openSafeTaxiDialog(dialogService);
    },
    modalService: true
  },
  {
    name: 'Bitcoin',
    slug: '/project/bitcoin',
    description: 'Descubre Bitcoin y su tecnología descentralizada.',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fcover3.webp?alt=media&token=95f2c1cd-4294-459c-9cea-39f755927eca'
    },
    link: '',
    buttonLabel: 'Más información',
    redirect: false,
    hasFunction: false
  },
  {
    name: 'Whitepaper de Bitcoin',
    slug: 'bitcoin-paper',
    description: 'Conoce el documento original de Satoshi Nakamoto.',
    assets: {
      backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fbtc%2Fbanner.webp?alt=media&token=a463e4b9-51a5-47bd-846f-67e368afcf4f'
    },
    link: '',
    buttonLabel: 'Leer Whitepaper',
    redirect: true,
    hasFunction: true,
    action: () => {
      window.open('https://drive.google.com/drive/folders/12h8N8zwQpEAqIBdZvafnWPXRkGrGt0pc?usp=sharing', '_blank');
    }
  }
];

export const GeneralInformation = {
  name: 'Cochabamba Ciudad Inteligente',
  typedArray: [
    'Cochabamba, Ciudad Inteligente!',
    'Cochabamba, Corazón del futuro!',
    'Cochabamba, Somos Innovación!',
    'Cochabamba, Somos Progreso!',
    'Cochabamba, Somos Salud!',
    'Cochabamba, la mejor ciudad de Bolivia!'
  ],
  description: 'Bienvenido a la plataforma de datos abiertos de la ciudad de Cochabamba. Este sitio sirve como una ventana unificada de información oficial relevante para el ciudadano.',
  assets: {
    backgroundUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fhome%2Fcristo-home.jpg?alt=media&token=69c25949-8798-421f-801e-1bec92d73068',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fhome%2Fcristo-home.jpg?alt=media&token=69c25949-8798-421f-801e-1bec92d73068',
  },
  rrss: RRSSLinks,
  slug: 'main',
  projects: Projects,
  gallery: [
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fhome%2Fcristo-home.jpg?alt=media&token=69c25949-8798-421f-801e-1bec92d73068',
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fhome%2Fcat-home.jpg?alt=media&token=f96ebf01-21a3-4f10-b8b2-7e836960e8ec',
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fvisita-cocha%2Fvisita-cocha-banner-home.jpg?alt=media&token=7b0e1700-048f-449d-9c5a-e6cc59becf2c',
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FpaginaCI%2Fhome%2Flaguna-home.webp?alt=media&token=a5a94f04-0a4d-4a37-8c2c-4be3d1635c95']
};

// FUNCTIONS
export function getInformation(slug: string) {
  switch (slug) {
    case 'main':
      return GeneralInformation;

    case 'projects':
      return Projects;

    case 'trash':
      return getInformationBySlug(Projects, 'trash');

    case 'parking':
      return getInformationBySlug(Projects, 'parking');

    case 'environment':
      return getInformationBySlug(Projects, 'environment');

    case 'traffic-light':
      return getInformationBySlug(Projects, 'traffic-light');

    case 'overpass':
      return getInformationBySlug(Projects, 'overpass');

    case 'panels':
      return getInformationBySlug(Projects, 'panels');

    case 'led':
      return getInformationBySlug(Projects, 'led');

    case 'app-innova':
      return getInformationBySlug(Projects, 'app-innova');

    case 'innova':
      return getInformationBySlug(Banners, 'app-innova');

    case 'map':
      return getInformationBySlug(Banners, 'map');

    case 'visita-cocha':
      return getInformationBySlug(Banners, 'visita-cocha');

    case 'taxiChecker':
      return getInformationBySlug(Banners, 'taxiChecker');

    case 'bikeway':
      return getInformationBySlug(Projects, 'bikeway');

    case 'bitcoin':
      return getInformationBySlug(Projects, 'bitcoin');

    case 'bitcoin-banner':
      return getInformationBySlug(Banners, '/project/bitcoin');

    case 'bitcoin-paper':
      return getInformationBySlug(Banners, 'bitcoin-paper');

    default:
      return GeneralInformation;
  }
};

export function getInformationBySlug(list: any[], slug: string) {
  return list.find((item: any) => item.slug === slug);
};

export function getMenuProjectItems() {
  return Projects.map(project => ({
    label: project?.name,
    icon: project?.features[0]?.icon || '',
    routerLink: '/project/' + project?.slug
  }));
};

function getDeviceType(): 'web' | 'android' | 'ios' {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/android/.test(userAgent)) {
    return 'android';
  }

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'ios';
  }

  return 'web';
};

function redirectBasedOnDevice(): void {
  const deviceType = getDeviceType();

  switch (deviceType) {
    case 'android':
      window.open('https://play.google.com/store/apps/details?id=bo.innova.gamc&hl');
      break;

    case 'ios':
      window.open('https://apps.apple.com/bo/app/innova-cochabamba/id1596809179');
      break;

    case 'web':
    default:
      window.open('https://innova.cochabamba.bo/login');
      break;
  }
};

function openSafeTaxiDialog(dialogService: DialogService): void {
  const ref: DynamicDialogRef | undefined = dialogService.open(SafeTaxiCheckerComponent, {
    closable: true,
    modal: true,
    dismissableMask: true,
    header: '.',
    position: 'bottom',
    data: {
      closeButton: false
    }
  });

  ref.onClose.subscribe(() => {
    const overlayElement = document.querySelector('.p-dialog-mask');

    if (overlayElement) {
      overlayElement?.parentNode?.removeChild(overlayElement);
    }
  });
}
